import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "signature-value" }
const _hoisted_4 = { class: "popup-header" }
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = { class: "popup-header" }
const _hoisted_8 = { class: "popup-content" }
const _hoisted_9 = { class: "input-wrapper" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { ref, computed, onMounted } from "vue";
import { showToast } from "vant";
import type { UploaderFileListItem, UploaderAfterRead } from "vant";
import { uploadAvatar, modifyUserInfo } from "@/api/system";
import { useStore } from "vuex";

interface FormData {
  avatar: string;
  nickName: string;
  slogan: string;
  gender: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'editProfile',
  setup(__props) {

const store = useStore();

// 简化的表单数据接口
const fileList = ref<UploaderFileListItem[]>([]);
const showNamePopup = ref(false);
const showSignaturePopup = ref(false);
const showGenderPicker = ref(false);

const userInfo = ref<any>({});

const formData = ref({
  avatar: '',
  gender: 0,
  nickName: '',
  slogan: '',
});

const genderOptions = [
  { text: '男', value: 0 },
  { text: '女', value: 1 }
];

// 修改性别显示逻辑
const genderText = computed(() => {
  switch (formData.value.gender) {
    case 0: return '男';
    case 1: return '女';
    default: return '';
  }
});

// 修改手机号格式化方法
const formatPhone = (phone: string) => {
  // 去掉前面的区号86，然后格式化手机号
  const phoneNumber = phone?.replace(/^86/, '') || '';
  return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
};

// 获取用户信息
const getUserInfoMethod = () => {
  const storageUserInfo = localStorage.getItem('userInfo');
  if (storageUserInfo) {
    const parsedUserInfo = JSON.parse(storageUserInfo);
    userInfo.value = parsedUserInfo;
    formData.value = {
      avatar: parsedUserInfo.avatar,
      nickName: parsedUserInfo.nickName,
      slogan: parsedUserInfo.slogan,
      gender: parsedUserInfo.gender,
    };
  }
};

// 头像上传
const afterRead: UploaderAfterRead = async (file) => {
  if (Array.isArray(file)) return;

  await uploadAvatar({ file: file.file as File }).then(res => {
    if (res.code === 200) {
      formData.value.avatar = res.data.avatar;
      store.dispatch('user/refreshUserInfo');
    }
  });
};

// 确认修改昵称
const onNameConfirm = () => {
  if (!formData.value.nickName.trim()) {
    showToast('昵称不能为空');
    return;
  }
  modifyUserInfo({
    nickName: formData.value.nickName
  }).then(res => {
    if (res.code === 200) {
      store.dispatch('user/refreshUserInfo');
      showNamePopup.value = false;
    } else {
      showToast(res.msg);
    }
  });
};

// 确认修改个性签名
const onSignatureConfirm = () => {
  modifyUserInfo({
    slogan: formData.value.slogan
  }).then(res => {
    if (res.code === 200) {
      store.dispatch('user/refreshUserInfo');
      showSignaturePopup.value = false;
    } else {
      showToast(res.msg);
    }
  });
};

// 确认性别选择
const onGenderConfirm = (value: any) => {
  formData.value.gender = Number(value.selectedValues[0]);
  modifyUserInfo({
    gender: Number(formData.value.gender)
  }).then(res => {
    if (res.code === 200) {
      store.dispatch('user/refreshUserInfo');
      showGenderPicker.value = false;
    } else {
      showToast(res.msg);
    }
  });
};

onMounted(() => {
  // 获取用户信息
  getUserInfoMethod();
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "详细资料" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_cell, {
        title: "头像",
        "is-link": ""
      }, {
        value: _withCtx(() => [
          _createVNode(_component_van_uploader, {
            modelValue: fileList.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
            "max-count": 1,
            "after-read": afterRead
          }, {
            default: _withCtx(() => [
              (formData.value.avatar)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: formData.value.avatar,
                    class: "avatar"
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createBlock(_component_van_icon, {
                    key: 1,
                    name: "photograph",
                    size: "44"
                  }))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_van_cell, {
        title: "昵称",
        value: formData.value.nickName,
        "is-link": "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showNamePopup.value = true))
      }, null, 8, ["value"]),
      _createVNode(_component_van_cell, {
        title: "账号",
        value: userInfo.value.onlyCode
      }, null, 8, ["value"]),
      _createVNode(_component_van_cell, {
        title: "手机号",
        value: formatPhone(userInfo.value.phoneNumber)
      }, null, 8, ["value"]),
      _createVNode(_component_van_cell, {
        title: "个性签名",
        "is-link": "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showSignaturePopup.value = true))
      }, {
        value: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(formData.value.slogan || ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_van_cell, {
        title: "性别",
        value: genderText.value,
        "is-link": "",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showGenderPicker.value = true))
      }, null, 8, ["value"]),
      _createVNode(_component_van_popup, {
        show: showNamePopup.value,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showNamePopup).value = $event)),
        position: "bottom",
        round: "",
        class: "edit-popup"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "修改昵称", -1)),
            _createVNode(_component_van_icon, {
              name: "cross",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showNamePopup.value = false))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.nickName) = $event)),
                type: "text",
                placeholder: "请输入昵称",
                class: "custom-input"
              }, null, 512), [
                [_vModelText, formData.value.nickName]
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "field-tip" }, "仅限中文、字母、数字和下划线", -1)),
            _createVNode(_component_van_button, {
              block: "",
              type: "primary",
              class: "confirm-btn",
              onClick: onNameConfirm
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("确定")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_popup, {
        show: showSignaturePopup.value,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showSignaturePopup).value = $event)),
        position: "bottom",
        round: "",
        class: "edit-popup"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "修改个性签名", -1)),
            _createVNode(_component_van_icon, {
              name: "cross",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showSignaturePopup.value = false))
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.slogan) = $event)),
                type: "text",
                placeholder: "请输入个性签名",
                class: "custom-input"
              }, null, 512), [
                [_vModelText, formData.value.slogan]
              ])
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "field-tip" }, "展示你的个性签名", -1)),
            _createVNode(_component_van_button, {
              block: "",
              type: "primary",
              class: "confirm-btn",
              onClick: onSignatureConfirm
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("确定")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_popup, {
        show: showGenderPicker.value,
        "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showGenderPicker).value = $event)),
        position: "bottom",
        round: "",
        class: "edit-popup"
      }, {
        default: _withCtx(() => [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "popup-header" }, "选择性别", -1)),
          _createVNode(_component_van_picker, {
            columns: genderOptions,
            onConfirm: onGenderConfirm,
            onCancel: _cache[10] || (_cache[10] = ($event: any) => (showGenderPicker.value = false)),
            "show-toolbar": ""
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})